export enum eActionType {
    DEPART = "depart",
    ARRIVE = "arrive",
    TURN = "turn",
    KEEP = "keep",
    ROUNDABOUT_ENTER = "roundaboutEnter",
    ROUNDABOUT_PASS = "roundaboutPass",
}